import React from 'react';
import PropTypes from 'prop-types';
// styles
import { TextFieldStyled } from '../../styles';

export const LastNameInputComponent = React.forwardRef(({
  value,
  onChange,
  onBlur,
  onClick,
  error,
  errorMessage,
  placeholder,
}, ref) => (
  <TextFieldStyled
    id='suspect-email-capture-form-last-name-input'
    label='Last name'
    ref={ref}
    name='lastName'
    value={value}
    error={error}
    errorMessage={errorMessage}
    onChange={onChange}
    onBlur={onBlur}
    onClick={onClick}
    required={true}
    maxLength={100}
    placeholder={placeholder} />
));

LastNameInputComponent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default LastNameInputComponent;
